import {
  OUT_OF_ORDER_PREVIEW,
  OUT_OF_ORDER_NEW,
  OUT_OF_ORDER_UPDATE,
  OUT_OF_ORDER_REMOVE,
  OUT_OF_ORDER_PROCESS_SUCCESS,
  OUT_OF_ORDER_DATASOURCE_SUCCESS,
  OUT_OF_ORDER_SEARCH,
  OUT_OF_ORDER_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case OUT_OF_ORDER_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case OUT_OF_ORDER_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case OUT_OF_ORDER_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case OUT_OF_ORDER_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case OUT_OF_ORDER_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case OUT_OF_ORDER_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case OUT_OF_ORDER_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case OUT_OF_ORDER_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}